module.exports = __webpack_public_path__ + "img/filter-list-solid.ae0b176c.svg";